import React, { memo } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Stack,
  IconButton,
  Icon,
  Box,
} from "investira.react.components";
import { validators, formats } from "investira.sdk";
import ConcentracaoTable from "./ConcentracaoTable";
import ConcentracaoGraph from "./ConcentracaoGraph";

const ConcentracaoGroup = memo((props) => {
  const { segmentos, detalhe, variant, onSetRegra } = props;

  if (variant === "SEG") {
    function filtrarPorSegmentoId(pData, pSegmentoId) {
      // Verifica se 'pData' é um array válido
      if (!Array.isArray(pData)) {
        console.error('O parâmetro "pData" deve ser um array.');
        return [];
      }

      // Filtra os itens onde segmento.id corresponde ao segmentoId fornecido
      return pData.filter((xItem) => {
        // Verifica se o item tem um segmento válido
        const xSegmento = xItem.segmento;
        if (!xSegmento || typeof xSegmento !== "object" || !xSegmento.id) {
          console.warn("Item sem segmento válido:", xItem);
          return false; // Ignora itens sem segmento válido
        }
        return xSegmento.id === pSegmentoId;
      });
    }

    return (
      <Stack spacing={4}>
        {segmentos.map((xItem) => {
          const xSegmentoDetalhe = filtrarPorSegmentoId(detalhe, xItem.id);

          return (
            <Stack key={`seg-${xItem.id}`}>
              <Stack direction={"row"} gap={1.5} alignItems="center">
                <Box
                  sx={{
                    width: "4px",
                    height: "20px",
                    backgroundColor: "primary.main",
                  }}
                />
                <Typography
                  color="textPrimary"
                  variant="subtitle2"
                  sx={{ fontWeight: 600 }}
                >
                  {xItem.descricao}
                </Typography>
              </Stack>
              <Stack>
                <ConcentracaoTable
                  detalhe={xSegmentoDetalhe}
                  onSetRegra={onSetRegra}
                  variant={variant}
                />
              </Stack>
            </Stack>
          );
        })}
      </Stack>
    );
  }

  if (variant === "EMI") {
    return (
      <Stack spacing={4}>
        <ConcentracaoTable
          detalhe={detalhe}
          onSetRegra={onSetRegra}
          variant={variant}
        />
      </Stack>
    );
  }

  if (variant === "CON") {
    return (
      <Stack spacing={4}>
        <ConcentracaoTable
          detalhe={detalhe}
          onSetRegra={onSetRegra}
          variant={variant}
        />
      </Stack>
    );
  }

  return null;
});

ConcentracaoGroup.displayName = "ConcentracaoGroup";

export default ConcentracaoGroup;
